<template>
  <div id="Login">
    <div class="container">
      <div class="card card-login mx-auto text-center">
          <div class="card-header mx-auto">
              <span> <img src="../../assets/logo_kibon.png" class="w-75" alt="Logo"> </span><br/>
              <span class="small" v-for="error in errors" v-bind:key="error">{{ error }}</span>
          </div>
          <div class="card-body">
              <form action="" method="post">
                  <div class="input-group form-group">
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fas fa-user"></i></span>
                      </div>
                      <input type="text" v-model="email" class="form-control" placeholder="Username">
                  </div>

                  <div class="input-group form-group">
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fas fa-key"></i></span>
                      </div>
                      <input type="password" v-model="senha" class="form-control" placeholder="Password">
                  </div>

                  <div class="form-group">
                      <input type="submit" v-on:click="login($event)" class="btn btn-primary float-right login_btn">
                  </div>

              </form>
          </div>
      </div>
    </div>
  </div>
</template>
<script>

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Login',
  data() {
    return{
      email: '',
      senha: '',
      errors: [],
    }

  },
  methods: {
    login(event){
      event.preventDefault();
      this.errors = [];
      if (!this.email){
        this.errors.push('Email inválido');
        return;
      }
      else if (this.email.search('@')<0){
        this.errors.push('Email inválido');
        return;
      }
      
      if (!this.senha)
        this.errors.push('Senha inválida');
      
      if (this.errors.length)
        return;
      

      firebase.auth().signInWithEmailAndPassword(this.email, this.senha).then(
        () => {
          this.$router.replace('/home')
        },
        () => {
          this.errors = [];
          this.errors.push('Email/senha não conferem');
        }
      );
    },
  }
}
</script>
<style scoped>
  body {
      background: #000 !important;
  }
  .card {
      background-color:rgb(255, 255, 255);
  }
  .card-login {
      margin-top: 130px;
      padding: 18px;
      max-width: 30rem;
  }

  .card-header {
      color: #fff;
      background-color: white !important;
      background-image: linear-gradient(to right, white, white,white, white, rgba(250,0,0,1), rgba(250,0,0,1), rgba(210,0,0,1), rgba(150,0,0,1));
      /*background: #ff0000;*/
      font-family: sans-serif;
      font-size: 20px;
      font-weight: 600 !important;
      margin-top: 10px;
      border-bottom: 0;
  }

  .input-group-prepend span{
      width: 50px;
      background-color: rgb(54, 54, 201);
      color: #fff;
      border:0 !important;
  }

  input:focus{
      outline: 0 0 0 0  !important;
      box-shadow: 0 0 0 0 !important;
  }

  .login_btn{
      width: 130px;
  }


  .form-control {
      display: block;
      width: 100%;
      height: calc(2.25rem + 2px);
      padding: 0.375rem 0.75rem;
      font-size: 1.2rem;
      line-height: 1.6;
      color: #66686b;
      background-color: transparent;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .input-group-text {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      padding: 0.375rem 0.75rem;
      margin-bottom: 0;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1.6;
      color: #66686b;
      text-align: center;
      white-space: nowrap;
      background-color: #e9ecef;
      border: 1px solid #ced4da;
      border-radius: 0;
  }
</style>


